"use client";

import { IconSoup } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { DietCardRow } from "@/features/cart/components/configure-diet/diet-card/diet-card-row";
import { DietMenuModal } from "@/features/diets/components/diet-menu-modal/diet-menu-modal";
import type { OmnibusConfiguredPrices } from "@/features/diets/helpers/omnibus";

/**
 * Diet card row opening the menu preview dialog.
 */
export const DietCardMenuRow = ({
  dietId,
  kcal,
  variant,
  compact,
  menuPrices,
}: {
  dietId: string;
  kcal?: string;
  variant?: string;
  compact?: boolean;
  // Configured quote shown in the preview header, as in the summary (MPL-1835).
  menuPrices?: OmnibusConfiguredPrices;
}) => {
  const t = useTranslations("diets.card");

  return (
    <div data-pw="check-menu-button">
      <DietMenuModal
        dietId={dietId}
        kcal={kcal}
        omnibusPrices={menuPrices}
        price={menuPrices?.price}
        trigger={
          <DietCardRow
            icon={<IconSoup className="size-5" stroke={1.5} />}
            label={compact ? t("menuShort") : t("menu")}
          />
        }
        variant={variant}
      />
    </div>
  );
};
